import PageSeo from "../components/PageSeo";
import Nd1SiteNav from "./components/Nd1SiteNav";
import Nd1SiteFooter from "./components/Nd1SiteFooter";
import PageTopbar from "../components/PageTopbar";
import Nd1InsightCard from "./components/Nd1InsightCard";
import { getNd1Insights } from "./nd1Insights";
import { buildBreadcrumbJsonLd, buildBreadcrumbNavItems, buildPublicPageUrl } from "../lib/pageSeo";
import { PUBLIC_BLOG_POSTS } from "../data/publicBlogPosts";
import "./nd1.css";

export default function Nd1BlogPage() {
  const insights = getNd1Insights();
  const blogUrl = buildPublicPageUrl("/blog");

  return (
    <div className="nd1-root">
      <PageSeo
        title="Insights & perspectives"
        description="Articles and videos on genuine hiring, broken job applications, and building a more human way to connect real people with real jobs."
        path="/blog"
        canonicalPath="/blog"
        schemaType="website"
        jsonLd={[
          buildBreadcrumbJsonLd([
            { name: "Home", url: buildPublicPageUrl("/") },
            { name: "Blog", url: blogUrl },
          ]),
          {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "Insights & perspectives",
            description:
              "Articles and videos on genuine hiring, broken job applications, and building a more human way to connect real people with real jobs.",
            url: blogUrl,
            inLanguage: "en-GB",
            hasPart: PUBLIC_BLOG_POSTS.map((post) => ({
              "@type": "BlogPosting",
              headline: post.title,
              url: buildPublicPageUrl(post.href),
              ...(post.publishedDate ? { datePublished: post.publishedDate } : {}),
            })),
          },
        ]}
      />

      <a href="#nd1-main" className="nd1-skip-link">
        Skip to content
      </a>

      <Nd1SiteNav />

      <main id="nd1-main">
        <section className="nd1-shell nd1-section">
          <PageTopbar
            breadcrumbsOnly
            breadcrumbItems={buildBreadcrumbNavItems([
              { name: "Home", path: "/" },
              { name: "Blog", path: "/blog", current: true },
            ])}
          />
          <div className="nd1-blog-head">
            <div className="nd1-eyebrow">Read our blog</div>
            <h1 className="nd1-blog-head__title">Insights &amp; perspectives</h1>
            <p className="nd1-blog-head__lede">
              Articles and videos exploring trust, authenticity, and human connection in modern
              hiring.
            </p>
          </div>

          <div className="nd1-blog-grid">
            {insights.map((post) => (
              <Nd1InsightCard key={post.href} post={post} />
            ))}
          </div>
        </section>
      </main>

      <Nd1SiteFooter />
    </div>
  );
}
